import { UseQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { TrackableItem } from 'types/trackables';

import { useTrackableItems } from './useTrackableItems';

type UseTrackableItemOptions = Omit<
  UseQueryOptions<TrackableItem, APIError>,
  'queryKey' | 'queryFn'
> & {
  queryKey?: string[];
  trackableListId?: string;
  trackableItemId?: string;
};

export function useTrackableItem({
  queryKey = ['trackable-item'],
  trackableListId,
  trackableItemId,
  enabled,
}: UseTrackableItemOptions = {}) {
  const result = useTrackableItems({
    queryKey,
    params: {
      trackable_list_id: trackableListId,
      trackable_item_ids: trackableItemId ? [trackableItemId] : undefined,
      limit: 1,
    },
    enabled: enabled !== undefined ? enabled : Boolean(trackableListId && trackableItemId),
  });

  return {
    ...result,
    data: result.data?.data?.[0],
  };
}
